import { useEffect, useState } from "react";
import { getRendezVousTechnicien } from "../../api/techniciens.api";
import EtatBadge from "../../components/RendezVous/EtatBadge";
import { updateEtatRendezVous, updateRemarque } from "../../api/rendezVousService.api";

const formatDateFR = (dateISO) => {
  if (!dateISO) return "";
  const date = dateISO.includes("T") ? dateISO.split("T")[0] : dateISO;
  const [y, m, d] = date.split("-");
  return `${d}/${m}/${y}`;
};

const calculerHeures = (heureDebut, heureFin) => {
  if (!heureDebut || !heureFin) return 0;
  const [h1, m1] = heureDebut.split(":").map(Number);
  const [h2, m2] = heureFin.split(":").map(Number);
  const debut = h1 * 60 + m1;
  const fin = h2 * 60 + m2;
  if (fin <= debut) return 0;
  return ((fin - debut) / 60).toFixed(2);
};

export default function MesRendezVous() {
  const [rdvs, setRdvs] = useState([]);
  const [filters, setFilters] = useState({
    client: "",
    etat: "",
    date: "",
    month: "",
    page: 1,
    limit: 10,
  });
  const [totalPages, setTotalPages] = useState(1);
  const [loadingEtat, setLoadingEtat] = useState(null);

  // 🔥 LOAD depuis DB
  const loadRDV = async () => {
    try {
      const res = await getRendezVousTechnicien(filters);

      setRdvs(
        res.data.data.map((rv) => ({
          ...rv,
          remarque_sauvegardee: !!rv.remarque, // true si existe en DB
          remarque: "", // input temporaire
        }))
      );

      setTotalPages(res.data.totalPages);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadRDV();
  }, [filters]);

  const updateFilter = (key, value) => {
    setFilters({ ...filters, [key]: value, page: 1 });
  };

  const changePage = (newPage) => {
    setFilters({ ...filters, page: newPage });
  };

  const onChangeEtat = async (id, newEtat) => {
    try {
      setLoadingEtat(id);
      await updateEtatRendezVous(id, { etat_travaux: newEtat });
      loadRDV();
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingEtat(null);
    }
  };

  const onEditRemarque = async (id, remarque) => {
    try {
      await updateRemarque(id, { remarque });
    } catch (err) {
      console.error(err);
      alert("Erreur sauvegarde remarque");
    }
  };

  return (
    <div>
      <h2>📅 Mes rendez-vous</h2>

      {/* FILTRES */}
      <div className="filters">
        <input
          type="text"
          placeholder="Client"
          value={filters.client}
          onChange={(e) => updateFilter("client", e.target.value)}
        />
        <select
          value={filters.etat}
          onChange={(e) => updateFilter("etat", e.target.value)}
        >
          <option value="">Tous les états</option>
          <option value="EN_ATTENTE">En attente</option>
          <option value="EN_COURS">En cours</option>
          <option value="TERMINE">Terminé</option>
        </select>
        <input
          type="date"
          value={filters.date}
          onChange={(e) => updateFilter("date", e.target.value)}
        />
        <input
          type="month"
          value={filters.month}
          onChange={(e) => updateFilter("month", e.target.value)}
        />
        <button onClick={loadRDV}>Filtrer</button>
      </div>

      {/* TABLE */}
      <table className="responsive-table">
        <thead>
          <tr>
            <th>Client</th>
            <th>Téléphone</th>
            <th>Adresse</th>
            <th>Date</th>
            <th>Heure début</th>
            <th>Type</th>
            <th>Note</th>
            <th>Heure fin</th>
            <th>État</th>
            <th>Remarque</th>
            <th>Heures</th>
          </tr>
        </thead>

        <tbody>
          {rdvs.length === 0 ? (
            <tr>
              <td colSpan="11">Aucun rendez-vous</td>
            </tr>
          ) : (
            rdvs.map((r) => (
              <tr key={r.id}>
                <td>{r.client}</td>
                <td>
                  <a href={`tel:${r.telephone}`}>{r.telephone}</a>
                </td>
                <td>{r.adresse}</td>
                <td>{formatDateFR(r.date_rdv)}</td>
                <td>{r.heure_debut}</td>
                <td>{r.type_entretien}</td>
                <td>{r.note}</td>
                <td>{r.heure_fin}</td>

                {/* ETAT */}
                <td>
                  {r.etat_travaux === "TERMINE" ? (
                    <EtatBadge etat={r.etat_travaux} />
                  ) : (
                    <select
                      disabled={loadingEtat === r.id}
                      value={r.etat_travaux}
                      onChange={(e) => onChangeEtat(r.id, e.target.value)}
                    >
                      <option value="EN_ATTENTE">En attente</option>
                      <option value="EN_COURS">En cours</option>
                      <option value="TERMINE">Terminé</option>
                    </select>
                  )}
                </td>

               {/* 🔥 REMARQUE */}
<td>
  {r.etat_travaux === "TERMINE" ? (
    !r.remarque_sauvegardee ? (
      <input
        value={r.remarque || ""}
        placeholder="Ajouter une remarque..."
        rows={3}
        onChange={(e) =>
          setRdvs((prev) =>
            prev.map((rv) =>
              rv.id === r.id
                ? { ...rv, remarque: e.target.value }
                : rv
            )
          )
        }
        onBlur={async () => {
          const rv = rdvs.find((rv) => rv.id === r.id);

          if (!rv.remarque?.trim()) return;

          await onEditRemarque(r.id, rv.remarque);

          // Masquer après sauvegarde
          setRdvs((prev) =>
            prev.map((item) =>
              item.id === r.id
                ? {
                    ...item,
                    remarque_sauvegardee: true,
                    remarque: "",
                  }
                : item
            )
          );
        }}
      />
    ) : (
      ""
    )
  ) : (
    "-"
  )}
</td>

                {/* HEURES */}
                <td>
                  {r.heure_fin
                    ? calculerHeures(r.heure_debut, r.heure_fin) + " h"
                    : "-"}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* PAGINATION */}
      <div className="pagination">
        <button
          disabled={filters.page <= 1}
          onClick={() => changePage(filters.page - 1)}
        >
          Précédent
        </button>
        <span>
          Page {filters.page} / {totalPages}
        </span>
        <button
          disabled={filters.page >= totalPages}
          onClick={() => changePage(filters.page + 1)}
        >
          Suivant
        </button>
      </div>
    </div>
  );
}